import React from 'react';
import Dropzone from 'react-dropzone';
import {
  Typography,
  Button,
  Icon,
} from '@mui/material';
import grey from '@mui/material/colors/grey';
import PropTypes from 'prop-types';

class FileUploadComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      file: null,
      error: null,
    };
  }

  onCancel = () => {
    this.setState({ file: null });
    this.props.onCancel();
  }

  handleDrop = (dropped) => {
    if (dropped && dropped[0]) {
      this.setState({
        file: dropped[0],
        error: null,
      }, () => {
        this.props.onChange(this.state.file);
      });
    }
  }

  handleDropRejected = () => {
    this.setState({ error: 'Error. Please make sure the file selected is under 100mb in size and has a name less that 255 characters in length.' });
  }

  render() {
    return (
      <div>
        {
          this.state.error
            && (
              <Typography color="error">
                {this.state.error}
              </Typography>
            )
        }
        {
          !this.state.file
            && (
              <Dropzone
                onDrop={this.handleDrop}
                onDropRejected={this.handleDropRejected}
                multiple={false}
                accept="image/*, text/*, application/*"
                maxSize={10000000}
              >
                {({
                  getRootProps,
                  getInputProps,
                }) => (
                  <div
                    {...getRootProps()}
                    style={{
                      backgroundColor: grey['50'],
                      border: `2px solid ${grey['200']}`,
                      borderRadius: '.5rem',
                      cursor: 'pointer',
                      color: grey['800'],
                      textAlign: 'center',
                      padding: '2rem 0rem',
                    }}
                  >
                    <Icon>
                      file_upload
                    </Icon>
                    <div>
                      Upload a file
                      <Typography variant="caption">Drop files here</Typography>
                      <input {...getInputProps()} />
                    </div>
                  </div>
                )}
              </Dropzone>
            )
        }
        {
          this.state.file
            && (
              <Typography>
                {this.state.file.name}
                <Button onClick={this.onCancel}>Remove</Button>
              </Typography>
            )
        }
      </div>
    );
  }
}

FileUploadComponent.propTypes = {
  onChange: PropTypes.func,
  onCancel: PropTypes.func,
};

FileUploadComponent.defaultProps = {
  onChange: () => {},
  onCancel: () => {},
};

export default FileUploadComponent;
